import Vue from 'vue'

/** @typedef {Object.<string, string>} subscribables */
/** @typedef {Object.<string, boolean>} displayRuleMap */
export default {
  state: {
    /** @type subscribables */
    subscribables: {},
    /** @type displayRuleMap */
    displayRuleMap: {},
  },
  mutations: {
    CLEAR_RULE_SUBSCRIBABLES (state) {
      state.subscribables = {}
    },
    SET_RULE_SUBSCRIBABLES (state, subscribables) {
      state.subscribables = subscribables
    },
    CLEAR_DISPLAY_RULE_MAP (state) {
      state.displayRuleMap = {}
    },
    SET_DISPLAY_RULE_REFERENCE (state, { reference, display }) {
      Vue.set(state.displayRuleMap, reference, display)
    },
    DELETE_DISPLAY_RULE_REFERENCE (state, reference) {
      Vue.delete(state.displayRuleMap, reference)
    },
  },
  actions: {
    set_rule_subscribables ({ commit }, subscribables) {
      commit('CLEAR_RULE_SUBSCRIBABLES')
      commit('SET_RULE_SUBSCRIBABLES', subscribables)
    },
    set_display_rule_reference ({ commit }, { reference, display }) {
      commit('SET_DISPLAY_RULE_REFERENCE', { reference, display })
    },
    delete_display_rule_reference ({ commit }, reference) {
      commit('DELETE_DISPLAY_RULE_REFERENCE', reference)
    },
    clear_display_rule_map ({ commit }) {
      commit('CLEAR_DISPLAY_RULE_MAP')
    },
  },
}
